import React, { useState } from "react";
import { MdClose } from "react-icons/md";
import { FaCheckCircle } from "react-icons/fa";

const ShareModal = ({ agency, onClose }) => {
  const [showToast, setShowToast] = useState(false);
  const pageUrl = window.location.href;

  const copyLink = () => {
    navigator.clipboard.writeText(pageUrl);
    setShowToast(true);

    setTimeout(() => {
      setShowToast(false);
    }, 2000);
  };

  const handleEmail = () => {
    const subject = `Share ${agency?.principal_name || "Agency"} details`;
    const body = `Check out this agency:\n${pageUrl}`;
    window.location.href = `mailto:?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
  };

  return (
    <>
      {/* Modal */}
      <div className="fixed inset-0 bg-black/40 flex justify-center items-center z-[9999]">
        <div className="bg-white w-[90%] max-w-[420px] rounded-xl shadow-lg p-6 relative">

          {/* Close */}
          <MdClose
            className="absolute top-4 right-4 cursor-pointer text-gray-600"
            size={22}
            onClick={onClose}
          />

          {/* Title */}
          <h2 className="text-lg font-semibold text-[#3D3B40] mb-4">
            Share {agency?.principal_name}'s details
          </h2>

          {/* Email */}
          <button
            onClick={handleEmail}
            className="w-full flex items-center gap-3 py-3 text-left hover:bg-gray-100 rounded-lg"
          >
            <span className="text-sm text-[#3D3B40]">📧 Email</span>
          </button>

          {/* Copy Link */}
          <button
            onClick={copyLink}
            className="w-full flex items-center gap-3 py-3 text-left hover:bg-gray-100 rounded-lg mt-1"
          >
            <span className="text-sm text-[#3D3B40]">🔗 Copy link</span>
          </button>
        </div>
      </div>

      {/* Success Toast */}
      {showToast && (
        <div className="fixed bottom-6 left-1/2 -translate-x-1/2 px-5 py-3 bg-[#3BB75E] text-white text-sm font-medium rounded-lg shadow-lg animate-slideUp flex items-center gap-2 z-[10000]">
          <FaCheckCircle size={18} />
          <span>Link copied to clipboard!</span>
        </div>
      )}

      {/* Animation */}
      <style>{`
        @keyframes slideUp {
          0% { opacity: 0; transform: translate(-50%, 20px); }
          100% { opacity: 1; transform: translate(-50%, 0px); }
        }

        .animate-slideUp {
          animation: slideUp 0.25s ease-out;
        }
      `}</style>
    </>
  );
};

export default ShareModal;
